<template>
  <div :class="fixCenter ? 'skeleton__fullHeight' : ''">
    <div class="skeleton__icon">
      <div class="skeleton__ufo">
        <img src="//coolcdn.igetcool.com/t/2020/1/1573a1f95f1ceceaa76ca62e59c72ee633.png">
      </div>
      <div class="skeleton__shadow">
        <img src="//coolcdn.igetcool.com/t/2020/1/1549ef8cc0d3fb0bcb46b46a4c2e02dfce.png">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    fixCenter: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isLoaded: false
    };
  },
  created() {
    // this.$nextTick(() => {
    //   let image = this.$refs.imageUrl;
    //   image.onload = () => {
    //     this.isLoaded = true;
    //   };
    // });
  },
};
</script>
<style lang="scss" scoped>
@keyframes shadow {
  0% {
    transform: scale(1)
  }
  50% {
    transform: scale(1.3)
  }
  100% {
    transform: scale(1)
  }
}
@keyframes ufo {
  0% {
    transform: rotate(0deg);
  }
  33% {
    transform: rotate(6deg)
  }
  50% {
    transform: rotate(0deg)
  }
  66% {
    transform: rotate(-6deg)
  }
  100% {
    transform: rotate(0deg)
  }
}
@keyframes ufoY {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(.08rem);
  }
  100% {
    transform: translateY(0);
  }
}
.skeleton {
  &__fullHeight {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__icon {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__ufo {
    width: .84rem;
    height: .5rem;
    margin-bottom: .2rem;
    transform-origin: center;
    animation: ufoY 2s infinite linear;

    img {
      width: 100%;
      display: block;
      transform-origin: center;
      animation: ufo 2s infinite linear;
    }
  }

  &__shadow {
    width: .44rem;
    height: .08rem;
    animation: shadow 2s infinite linear;

    img {
      width: 100%;
      display: block;
    }
  }
}
</style>